import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
Vue.use(Router)
// 解决路由重复导航报错问题
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
  routes: [{
      path: '/',
      redirect: '/login'
    },
    // 登录
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/index.vue')
    },
    // 注册
    {
      path: '/enroll',
      name: 'enroll',
      component: () => import('@/views/login/enrollde.vue')
    },
    // 个人账号登录
    {
      path: '/personLogin',
      name: 'personLogin',
      component: () => import('@/views/login/personLogin.vue')
    },

    // 首页
    {
      path: '/index',
      name: 'index',
      component: () => import('@/views/index/index.vue')
    },

    // 高级检索页面
    {
      path: '/advancedSearch',
      name: 'advancedSearch',
      component: () => import('@/views/advancedSearch/index.vue')
    },
    // 检索列表页面
    {
      path: '/search',
      name: 'search',
      component: () => import('@/views/search/index.vue')
    },
    // 学校列表页面
    {
      path: '/schoolList',
      name: 'schoolList',
      component: () => import('@/views/schoolList/index.vue')
    },
    // 检索历史页面
    {
      path: '/searchHistory',
      name: 'searchHistory',
      component: () => import('@/views/searchHistory/index.vue')
    },
    // 详情页面
    {
      path: '/detail/:id',
      name: 'detail',
      component: () => import('@/views/detail/index.vue')
    },
    // 学校概况页面
    {
      path: '/schoolDetail/:cid',
      name: 'schoolDetail',
      component: () => import('@/views/schoolDetail/schoolDetail.vue')
    },
    {
      path: '/left',
      name: 'left',
      component: () => import('../views/search/left.vue')
    },
    // 个人中心
    {
      path: '/users',
      name: 'users',
      component: () => import('../views/users/index.vue')
    },
    // 404
    {
      path: '/*',
      name: '404',
      component: () => import('@/views/404/index.vue')
    },




  ]
})
router.beforeEach((to, from, next) => {
  console.log('to.path',to.path,to)
  // next()
  if (to.path === '/') {
    
    next()
  } else if ((to.query.type || to.query.source) && (to.query.type == 'ql'|| to.query.source == 'xn') && to.path === '/index') {
   
    next()
  } else if (to.path !== '/login' && !store.getCookie("token")) {
    
    return next('/login')
  } else {
    next()
  }

})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js